module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Medium.67eb6162.woff";